export default __webpack_public_path__ + "static/media/mernorg.546e824b.png";